import { apiGet, apiPut } from './api';
import type {
  NewNotifications,
  NotificationConfig,
  NotificationItem,
  NotificationPage,
  NotificationPreferenceConfig,
  NotificationPreferenceResponse,
  NotificationSummary,
} from '../types/notification';

export interface ListParams {
  limit?: number;
  cursor?: string | null;
  status?: 'all' | 'unread' | 'archived';
  type?: string;
  classroomCode?: string;
  q?: string;
}

function query(params: Record<string, string | number | null | undefined>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined && `${v}`.length > 0) search.set(k, `${v}`);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function getNotificationConfig(): Promise<NotificationConfig> {
  return apiGet<NotificationConfig>('/api/notifications/config');
}

export function listNotifications(params: ListParams): Promise<NotificationPage> {
  return apiGet<NotificationPage>(`/api/notifications${query({ ...params })}`);
}

export function getNotificationSummary(): Promise<NotificationSummary> {
  return apiGet<NotificationSummary>('/api/notifications/summary');
}

export function getNewNotifications(params: {
  afterCreatedRevision: string;
  throughCreatedRevision?: string;
  cursor?: string | null;
  limit?: number;
}): Promise<NewNotifications> {
  return apiGet<NewNotifications>(`/api/notifications/new${query({ ...params })}`);
}

export function getNotification(id: string): Promise<NotificationItem> {
  return apiGet<NotificationItem>(`/api/notifications/${id}`);
}

export function setNotificationRead(id: string, read: boolean): Promise<NotificationSummary> {
  return apiPut<NotificationSummary>(`/api/notifications/${id}/read`, { read });
}

export function markAllNotificationsRead(
  throughCreatedRevision: string,
): Promise<NotificationSummary> {
  return apiPut<NotificationSummary>('/api/notifications/read-all', { throughCreatedRevision });
}

export function setNotificationArchived(
  id: string,
  archived: boolean,
): Promise<NotificationSummary> {
  return apiPut<NotificationSummary>(`/api/notifications/${id}/archive`, { archived });
}

export function getNotificationPreferences(): Promise<NotificationPreferenceResponse> {
  return apiGet<NotificationPreferenceResponse>('/api/notifications/preferences');
}

export function saveNotificationPreferences(
  version: number,
  config: NotificationPreferenceConfig,
): Promise<NotificationPreferenceResponse> {
  return apiPut<NotificationPreferenceResponse>('/api/notifications/preferences', {
    version,
    config,
  });
}
